import PolicyBank from './PolicyBank'

export default PolicyBank
